import React from 'react';
import { FirstLoadPopup } from '../popup';
import Footer from './footer';
import Header from './header';

interface LayoutProps {
  children?: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <Header />
      <FirstLoadPopup />
      {children}
      <Footer />
    </>
  )
}

export default Layout
